// src/locales/en/paymentVerification.js
export const paymentVerification = {
  // Page
  pageTitle: "Payment Verification",
  pageDescription: "Review and verify payment records submitted by staff",

  // Columns
  orderNumber: "Order #",
  paymentMethod: "Payment Method",
  paymentType: "Payment Type",
  amount: "Amount",
  reference: "Payment Ref",
  paymentDate: "Payment Date",
  proof: "File",
  isVerified: "Is Verified",
  action: "Action",
  createdBy: "Created By",
  createdDate: "Created Date",
  verifiedBy: "Verified By",
  verifiedDate: "Verified Date",
  voidedBy: "Voided By",
  voidedDate: "Voided Date",

  // Status
  verified: "Verified",
  unverified: "Unverified",
  issues: "Issues",
  void: "Void",

  // Filters
  allPaymentMethods: "All Payment Methods",
  allPaymentTypes: "All Payment Types",
  allStatuses: "All",
  verifiedOnly: "Verified",
  unverifiedOnly: "Unverified",
  searchPlaceholder: "Search by order number or reference...",

  // Proof
  noFileChosen: "No file chosen",
  viewProof: "View",
  viewProofPdf: "View uploaded PDF",
  changeProof: "Change",
  deleteProof: "Delete",
  confirmDeleteProof: "Remove the uploaded payment proof for this record?",

  // Actions
  verify: "Verify",
  save: "Save",
  verifySelected: "Verify Selected ({{count}})",
  clearSelection: "Clear Selection",
  confirmVerify: "Mark this payment record as verified?",
  confirmBulkVerify: "Verify {{count}} selected payment record(s)? This cannot be undone.",

  // Void
  confirmVoid: "Voiding invalidates this payment record. This does not change the order's paid amount.",
  voidReasonLabel: "Reason for voiding",

  // Issues
  flagAsIssue: "Flag as Issue",
  flagIssueDescription: "Flag this payment record as having an issue so call center staff can follow up with the customer.",
  flagIssueReasonLabel: "Describe the issue",
  resolve: "Resolve",
  resolveDescription: "Move this payment record back to Unverified once the issue is resolved.",
  resolveNoteLabel: "Resolution note (optional)",

  // Notes
  notes: "Notes",
  addNote: "Add Note",
  notePlaceholder: "Add a note about this payment record...",
  noNotesYet: "No notes yet",

  // Messages
  verifySuccess: "Payment record verified successfully",
  verifyFailed: "Failed to verify payment record",
  bulkVerifySuccess: "Successfully verified {{count}} payment record(s)",
  bulkVerifyPartial: "Verified {{successCount}} of {{totalSubmitted}} record(s); {{failureCount}} failed",
  bulkVerifyFailed: "Failed to verify selected payment records",
  updateSuccess: "Payment record updated successfully",
  updateFailed: "Failed to update payment record",
  proofUploadFailed: "Failed to upload payment proof",
  cannotEditVerified: "Verified records cannot be edited",
  noUnverifiedSelected: "Select at least one unverified record",
  failedToLoad: "Failed to load payment records",
  noRecordsFound: "No Payment Records Found",
  noRecordsFoundDescription: "No payment records match your search criteria",
  voidSuccess: "Payment record voided successfully",
  voidFailed: "Failed to void payment record",
  flagIssueSuccess: "Payment record flagged as having an issue",
  flagIssueFailed: "Failed to flag payment record",
  resolveSuccess: "Payment record issue resolved",
  resolveFailed: "Failed to resolve payment record issue",
  noteAddSuccess: "Note added successfully",
  noteAddFailed: "Failed to add note",
  notesLoadFailed: "Failed to load notes",
  referenceRequiredForBankTransfer: "Payment reference is required to verify a bank transfer payment",
  saveChangesBeforeVerify: "Save your changes before verifying this payment",
  bulkUnsavedChanges: "{{count}} selected payment record(s) have unsaved changes. Save them before verifying.",
  bulkReferenceMissing: "{{count}} selected bank transfer payment(s) have no payment reference. Add references before verifying.",
};
